
// COMPLETED SCENARIO LOGS  
export const LOGS = {
  OPTIMIZATION_WARNINGS : {
    'Solve interrupted' : 'Sub-optimal solution \nSolve interrupted \nProduction and Demand values might be inaccurate',
    'Time limit reached' : 'Sub-Optimal solution \nPrediction Duration too long',
  }
}

export const GEOGRAPHY_LABELS = {
  "Market" : "Market Name",
  "Macro Zone" : "Macro Zone",
  "CBU" : "CBU Name",
}


// SCENARIO CREATION FORM
// VERSIONS ALLOWED TO CHANGE
export const ENABLED_FIELDS = {
  NO_ID : ['type', 'cycle_year', 'cycle_month', 'name', 'description'],
  BASE : [
    'type', 'cycle_year', 'cycle_month', 'name', 'description', 'technologies',
    'prediction_duration',
  ],
  REDUCED_SCOPE : [
    'type', 'cycle_year', 'cycle_month', 'name', 'description', 'technologies', 'factories', 'parent',
    'fg_capacity_version', 'sfg_capacity_version', 'fg_release_rates_version', 'fg_run_rates_version',
    'sfg_release_rates_version', 'sfg_release_rates_version', 'sfg_run_rates_version',
    'optimization_moves_capacity', 'optimization_move_capacity_step',
    'optimization_max_fg_transfers', 'optimization_max_sfg_transfers',
  ],
}

// LIST OF VERSIONS
export const ALL_VERSIONS = [ "apo_attributes_version", "apo_bom_wrc_version", "bom_version", "bpc_hierarchy_mapping_version", "cbus_hierarchies_version", 
  "conversion_rates_version", "dummy_skus_version", "demand_forecasts_version", "demand_actuals_version", "demand_risks_opps_version", 
  "demand_rf_gps_version", "factory_names_version", "fg_capacity_version", "fg_release_rates_version", "fg_run_rates_version", 
  "fg_transfer_rules_version", "fg_init_allocation_version", "fx_rates_version", "hierarchy_stage_mapping_version", "innovations_version",
  "line_feasibility_fg_version", "line_feasibility_sfg_version", "line_techno_scope_version", "location_mapping_version", "manual_bom_version", 
  "min_availability_version", "moq_version", "oe_ou_actuals_version", "out_of_scope_sfg_dem_version", "planned_stock_version", 
  "planned_transfers_version", "plants_hierarchies_version", "prices_version", "product_hierarchy_version", "production_plan_version", 
  "rp_alerts_version", "rp_purchasing_actuals_version", "sap_production_plan_version", "scope_supply_point_version", "seasonal_bom_version", 
  "sfg_capacity_version", "sfg_consumption_actuals_version", "sfg_release_rates_version", "sfg_run_rates_version", "sourcing_sfg_version", 
  "standard_cost_prices_version", "stock_version", "stock_target_version", "third_parties_sourcing_version", "transports_version", 
  "transports_leadtimes_version" 
]

// VERSION TYPE MAPPING
export const VERSION_TYPES = [
  ['apo_attributes_version', 'apo_attributes'],
  ['apo_bom_wrc_version', 'apo_bom_wrc'],
  ['bom_version', 'bom'],
  ['bpc_hierarchy_mapping_version', 'bpc_hierarchy_mapping'],
  ['cbus_hierarchies_version', 'cbus_hierarchies'],
  ['conversion_rates_version', 'conversion_rates'],
  ['dummy_skus_version', 'dummy_skus'],
  ['demand_forecasts_version', 'demand_forecasts'],
  ['demand_actuals_version', 'demand_actuals'],
  ['demand_risks_opps_version', 'demand_risks_opps'],
  ['demand_rf_gps_version', 'demand_rf_gps'],
  ['factory_names_version', 'factory_names'],
  ['fg_capacity_version', 'fg_capacity'],
  ['fg_release_rates_version', 'fg_release_rates'],
  ['fg_run_rates_version', 'fg_run_rates'],
  ['fg_transfer_rules_version', 'fg_transfer_rules'],
  ['fg_init_allocation_version', 'fg_init_allocation'],
  ['fx_rates_version', 'fx_rates'],
  ['hierarchy_stage_mapping_version', 'hierarchy_stage_mapping'],
  ['innovations_version', 'innovations'],
  ['line_feasibility_fg_version', 'line_feasibility_fg'],
  ['line_feasibility_sfg_version', 'line_feasibility_sfg'],
  ['line_techno_scope_version', 'line_techno_scope'],
  ['location_mapping_version', 'location_mapping'],
  ['manual_bom_version', 'manual_bom'],
  ['min_availability_version', 'min_availability'],
  ['moq_version', 'moq'],
  ['oe_ou_actuals_version', 'oe_ou_actuals'],
  ['out_of_scope_sfg_dem_version', 'out_of_scope_sfg_dem'],
  ['planned_stock_version', 'planned_stock'],
  ['planned_transfers_version', 'planned_transfers'],
  ['plants_hierarchies_version', 'plants_hierarchies'],
  ['prices_version', 'prices'],
  ['product_hierarchy_version', 'product_hierarchy'],
  ['production_plan_version', 'production_plan'],
  ['rp_alerts_version', 'rp_alerts'],
  ['rp_purchasing_actuals_version', 'rp_purchasing_actuals'],
  ['sap_production_plan_version', 'sap_production_plan'],
  ['scope_supply_point_version', 'scope_supply_point'],
  ['seasonal_bom_version', 'seasonal_bom'],
  ['sfg_capacity_version', 'sfg_capacity'],
  ['sfg_consumption_actuals_version', 'sfg_consumption_actuals'],
  ['sfg_release_rates_version', 'sfg_release_rates'],
  ['sfg_run_rates_version', 'sfg_run_rates'],
  ['sourcing_sfg_version', 'sourcing_sfg'],
  ['standard_cost_prices_version', 'standard_cost_prices'],
  ['stock_version', 'stock'],
  ['stock_target_version', 'stock_target'],
  ['third_parties_sourcing_version', 'third_parties_sourcing'],
  ['transports_version', 'transports'],
  ['transports_leadtimes_version', 'transports_leadtimes']
];